import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useData } from "data/data-provider";
import { carsLabel, fleetCategories } from "./categories";
import { CarArt, carKind } from "./typeArt";

/**
 * The home page's type strip (1NOW-11175): one card per fleet class: a drawn car of that kind on
 * an accent band (Taha picked option C, 7 Oct; tenant photos made the row look two-part), its name
 * and how many there are. A tile sends the class as
 * `?class=<encoded name>`, which the Vehicles page filters by (1NOW-11128). Nothing is drawn
 * for a fleet with no classes. Phones scroll the row; wider screens wrap it, and the tiles
 * grow to fill the last row rather than leave it half empty.
 */
const CarLogo = () => {
  const { ourVehicles } = useData();
  const navigate = useNavigate();
  const categories = useMemo(() => fleetCategories(ourVehicles), [ourVehicles]);

  if (categories.length === 0) return null;

  return (
    <section className="container" aria-labelledby="db-cats-title">
      <div className="mb-6 sm:mb-8">
        <h2 id="db-cats-title" className="db-title">
          Browse by type
        </h2>
        <p className="db-sub">Pick a type to see the cars in it.</p>
      </div>

      <ul className="db-cats">
        {categories.map((category) => (
          <li key={category.name} className="db-cats__item">
            <button
              type="button"
              className="db-cat"
              onClick={() => navigate("/vehicles?class=" + encodeURIComponent(category.name))}
            >
              <span className="db-cat__band">
                <CarArt kind={carKind(category.name)} className="db-cat__art" />
              </span>
              <span className="db-cat__body">
                <span className="db-cat__name">{category.name}</span>
                <span className="db-cat__count">{carsLabel(category.count)}</span>
                <span className="db-cat__go" aria-hidden="true">
                  View cars →
                </span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CarLogo;
